import { ThumbsUpDownOutlined } from "@material-ui/icons";
import IComponent from "components/commons/IComponent";
import "./PanelBase.scoped.css";
import "./Recorder.scoped.css";

class Recorder extends IComponent {
  recordTimer = 0;
  mediaRecorder = null;
  recordedChunks = null;
  constructor(props) {
    super(props);
    this.state = {
      isRecording: false,
      recordedTime: 0,
    };
  }
  componentDidMount() {}
  componentWillUnmount() {}
  toggleRecording(isRecording) {
    if (isRecording) {
      this.stopRecording();
    } else {
      this.recordVideo();
    }
    this.setState({ isRecording: !isRecording, recordedTime: 0 });
    this.toggleActionBtn();
  }
  recordVideo() {
    var canvas = document.querySelector("canvas");

    // FPS can be adjusted
    var stream = canvas.captureStream(25);

    console.log(stream);
    var options = { mimeType: "video/webm; codecs=vp8" };
    options = { mimeType: "video/webm" };
    this.mediaRecorder = new MediaRecorder(stream, options);

    this.mediaRecorder.ondataavailable = this.handleDataAvailable.bind(this);
    this.mediaRecorder.start();

    this.recordTimer = setInterval(
      () => this.setState((state) => (state.recordedTime++, state)),
      1000
    );
  }
  stopRecording() {
    clearInterval(this.recordTimer);
    this.recordedChunks = [];
    this.mediaRecorder.stop();
  }

  handleDataAvailable(event) {
    if (event.data.size > 0) {
      this.recordedChunks.push(event.data);
      this.downloadVideo();
    }
  }

  downloadVideo = function() {
    var blob = new Blob(this.recordedChunks, {
      type: "video/webm",
    });
    var url = URL.createObjectURL(blob);
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = "VideoCapture.webm";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  toggleActionBtn() {
    let actionBar = document.querySelector(
      ".actionBtns.spacer.EqualWidthChildren"
    );
    actionBar.classList[!this.state.isRecording ? "add" : "remove"]("disabled");
  }

  recordCloseAndHide() {
    clearInterval(this.recordTimer);
    this.props.mapUICallback("hideAllPanel");
  }

  render() {
    let { isRecording, recordedTime } = this.state;
    let hour = 0,
      min = 0,
      sec = 0;
    if (isRecording) {
      sec = recordedTime % 3600;
      min = Math.floor(recordedTime / 60);
      hour = Math.floor(recordedTime / 60 / 60);
      sec = sec < 10 ? "0" + sec : sec;
      min = min < 10 ? "0" + min : min;
      hour = hour < 10 ? "0" + hour : hour;
    }
    return (
      <div>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>Recorder</span>
          <span />
          <div className="RecordTimer">
            <span
              className={`icon_l ${
                isRecording ? "icn_3d_stoprecord colored" : "icn_3d_startrecord"
              }`}
              onClick={() => this.toggleRecording(isRecording)}
              style={{ height: "42px", width: "42px" }}
            />
            {isRecording && (
              <span className="TimeText">{`${hour}:${min}:${sec}`}</span>
            )}
          </div>
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={() => this.recordCloseAndHide()}
          />
        </div>
        <div className="SubPanelContent PanelContent">
          {isRecording
            ? "Click the recoding button to stop and save the video."
            : "Click the Record button to start recording, it will record the action on the mpa only. Without the data on the information panel."}
        </div>
      </div>
    );
  }
}

export default Recorder;
